
import { CssBaseline, ThemeProvider } from '@mui/material';
import './App.css';
import { Bar } from './MainPage/Bar';
import MainPage from './MainPage/MainPage';
import { theme } from './MainPage/styles';
import Footer from './MainPage/Footer';
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from 'react-router-dom';
import getRoutes from './routes';
import { Suspense } from 'react';
import LoadingBackdrop from './Components/LoadingBackdrop/LoadingBackdrop';

function RouteControl({ ...props }) {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Bar />
        <div style={{ minHeight: '92vh' }}>
          <Outlet />
        </div>
        <Footer />
      </ThemeProvider>
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: "/*",
    element: <RouteControl />,
    children: getRoutes(),
  },
  {
    path: "*",
    element: <Navigate to={`/`} replace />,
  }
]);

function App() {
  return (
    <Suspense fallback={<LoadingBackdrop open={true} />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default App;
